export const getInitialsFromString = (name: string): string =>
  name
    .split(" ")
    .map((chr) => chr[0])
    .join("") ?? ""

export const getInitialsFromUser = (user: BasicUserInfo) =>
  `${user.firstName
    ?.split(" ")
    .map((n) => n[0])
    .slice(0, 4)
    .join("")
    .toUpperCase()} ${user.lastName
    ?.split(" ")
    .map((n) => n[0])
    .join("")
    .slice(0, 4)
    .toUpperCase()}`.trim()
